import { Component, OnInit } from '@angular/core';
import { NgOption } from '@ng-select/ng-select';
import { AuthService } from 'src/app/Service/auth.service';
import { SharedConstants, User } from 'src/app/models';
import { EnumUserRol } from 'src/app/models/shared/app-enums';
import { CatGeneric } from 'src/app/models/shared/cat-generic';

@Component({
  selector: 'app-header-emi',
  templateUrl: './header-emi.component.html'
})
export class HeaderEmiComponent implements OnInit {

  name: string;
  companyName: string = "NOMBRE DE LA EMPRESA S.A. DE C.V.";
  roles: NgOption[];
  userIsSuperAdmin: boolean = false;
  currentUser: User;
  id: number;
  catLang: CatGeneric[] = [];
  animals: any;
  language: string;
  imgPath: string = "";


  constructor(
    private readonly authService: AuthService,
    private readonly sharedConstants: SharedConstants) {

    this.catLang.push({ id: 1, name: "Español", value: "es" });
    this.catLang.push({ id: 2, name: "English", value: "en" });

    this.roles = this.sharedConstants.roles;
    this.authService.currentUser.subscribe(resp => {
      console.log("currentUser=>", resp);
      this.companyName = localStorage.getItem('companyName');

      if (resp) {
        this.currentUser = resp;
        try {
          if (resp.roles) {
            resp.roleName = this.roles.find(i => i.valueLogin === resp.roles[0].rol) ?
              this.roles.find(i => i.valueLogin === resp.roles[0].rol).name : '';
            if (resp.roles[0].id == EnumUserRol.SUPER_ADMIN) {
              this.userIsSuperAdmin = true;
            }
          }

          this.id = this.currentUser.id;
          this.name = this.currentUser.username;
          if (this.name == 'null')
            this.name = 'USUARIO NO IDENTIFICADO';
          localStorage.setItem("userId", this.currentUser.id.toString());
        } catch (ex) {
          console.error(ex);
        }
      }
      else {
        this.currentUser = null;
      } 
    });
  }

  ngOnInit(): void {
    console.log("ngOnInit");
  }

  toggleSideBar() {
    $('#sidebar').addClass('active');
    $('.overlay').addClass('active');
    $('.collapse.in').toggleClass('in');
    $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  }


}
